<form
  class="edit-form"
  *ngIf="!isLoading && editForm"
  [formGroup]="editForm"
  (submit)="onSubmit()"
>
  <section class="firstLine">
    <mat-form-field *ngIf="!isAdmin">
      <mat-label>{{
        "repository.clients.edit.name.label" | translate
      }}</mat-label>
      <input type="text" matInput formControlName="name" />
      <mat-error>{{
        "repository.clients.edit.name.errorMessage" | translate
      }}</mat-error>
    </mat-form-field>
  </section>

  <mat-form-field>
    <mat-label>{{
      "repository.clients.edit.email.label" | translate
    }}</mat-label>
    <input type="text" matInput formControlName="email" />
    <mat-error>{{
      "repository.clients.edit.email.errorMessage" | translate
    }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{
      "repository.clients.edit.phone.label" | translate
    }}</mat-label>
    <input type="text" matInput formControlName="phone" />
    <mat-error>Mauvais format de téléphone</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ "repository.clients.edit.fax.label" | translate }}</mat-label>
    <input type="text" matInput formControlName="fax" />
    <mat-error>{{
      "repository.clients.edit.fax.errorMessage" | translate
    }}</mat-error>
  </mat-form-field>

  <br />

  <mat-form-field>
    <mat-label>{{
      "repository.clients.edit.contact.label" | translate
    }}</mat-label>
    <input type="text" matInput formControlName="contact" />
    <mat-error>{{
      "repository.clients.edit.contact.errorMessage" | translate
    }}</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{
      "repository.clients.edit.webSite.label" | translate
    }}</mat-label>
    <input type="text" matInput formControlName="webSite" />
    <mat-error>Le site ne peut dépasser 50 caractères</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{
      "repository.clients.edit.street.label" | translate
    }}</mat-label>
    <input type="text" matInput formControlName="street" />
    <mat-error>La rue ne peut dépasser 250 caractères</mat-error>
  </mat-form-field>

  <br />

  <mat-form-field>
    <mat-label>{{
      "repository.clients.edit.streetNumber.label" | translate
    }}</mat-label>
    <input type="text" matInput formControlName="streetNumber" />
    <mat-error>Le numéro de rue ne peut dépasser 50 caractères</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{
      "repository.clients.edit.locality.label" | translate
    }}</mat-label>
    <input type="text" matInput formControlName="locality" />
    <mat-error>La ville ne peut dépasser 50 caractères</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{
      "repository.clients.edit.postalCode.label" | translate
    }}</mat-label>
    <input type="text" matInput formControlName="postalCode" />
    <mat-error>Le code postal ne peut dépasser 50 caractères</mat-error>
  </mat-form-field>

  <br />

  <mat-form-field>
    <mat-label>{{
      "repository.clients.edit.siret.label" | translate
    }}</mat-label>
    <input type="text" matInput formControlName="siret" />
    <mat-error>Le siret ne peut dépasser 14 caractères</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ "repository.clients.edit.ape.label" | translate }}</mat-label>
    <input type="text" matInput formControlName="ape" />
    <mat-error>L'APE ne peut dépasser 5 caractères</mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ "repository.clients.edit.tva.label" | translate }}</mat-label>
    <input type="text" matInput formControlName="tva" />
    <mat-error>La TVA ne peut dépasser 13 caractères</mat-error>
  </mat-form-field>

  <br />
  <mat-slide-toggle
    *ngIf="!isAdmin"
    color="primary"
    formControlName="isSubcontractor"
    style="margin-bottom: 10px"
  >
    Agence sous-traitante
  </mat-slide-toggle>

  <fieldset class="default-site-field" *ngIf="editForm.get('site')">
    <legend>
      {{ "repository.clients.edit.defaultSite.label" | translate }}
      <mat-icon
        class="default-site-info"
        [matTooltip]="'repository.clients.edit.defaultSite.tooltip' | translate"
        [attr.aria-label]="
          'repository.clients.edit.defaultSite.tooltip' | translate
        "
        >info_outline</mat-icon
      >
    </legend>
    <mat-form-field>
      <mat-label>{{
        "repository.clients.edit.defaultSite.label" | translate
      }}</mat-label>
      <mat-select formControlName="site" [compareWith]="compareSites">
        <mat-option [value]="null">{{
          "repository.clients.edit.defaultSite.none" | translate
        }}</mat-option>
        <mat-option *ngFor="let site of sites" [value]="site">{{
          site.display
        }}</mat-option>
      </mat-select>
    </mat-form-field>
  </fieldset>

  <!-- <fieldset class="featuresFieldset" *ngIf="!isAdmin">
    <legend>Accès aux modules</legend>
    <label formArrayName="features" *ngFor="let feature of featuresFormArray.controls; let i = index">
      <mat-checkbox [formControlName]="i" color="primary">{{ allFeatures[i].name }}</mat-checkbox>
    </label>
  </fieldset> -->

  <app-validate-and-cancel
    (submitEvent)="endForm($event)"
    [editForm]="editForm"
    [disabling]="editForm.invalid"
  ></app-validate-and-cancel>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="primary"></mat-spinner>
